import { render, staticRenderFns } from "./Plays.vue?vue&type=template&id=5a54b3cb"
import script from "./Plays.vue?vue&type=script&lang=js"
export * from "./Plays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports